import { Icon } from '@petsmart-ui/sparky';
import Link from 'next/link';

import { useServicesLinkClick } from '../../../../../../shared';

import './level.scss';

export type LevelEntry = {
    href?: string;
    id: string;
    label: string;
    onSelect?: (trigger: HTMLElement) => void;
    openInNewTab?: boolean;
    sale?: boolean;
};

type LevelProps = {
    entries: LevelEntry[];
    label: string;
    root?: boolean;
};

export function Level({ entries, label, root = false }: LevelProps) {
    const handleServicesLinkClick = useServicesLinkClick();

    return (
        <ul aria-label={label} className={`mobile-menu-level${root ? ' mobile-menu-level--root' : ''}`}>
            {entries.map(entry => (
                <li key={entry.id} className="mobile-menu-level__item">
                    {entry.href ? (
                        <Link
                            href={entry.href}
                            className={`mobile-menu-level__row${entry.sale ? ' mobile-menu-level__row--sale' : ''}`}
                            rel={entry.openInNewTab ? 'noopener noreferrer' : undefined}
                            target={entry.openInNewTab ? '_blank' : undefined}
                            onClick={event => {
                                handleServicesLinkClick({
                                    event,
                                    link: entry.href,
                                    shouldOpenInNewTab: entry.openInNewTab,
                                });
                                entry.onSelect?.(event.currentTarget);
                            }}
                        >
                            <span>{entry.label}</span>
                            {root && <Icon name="chevron-right" size="lg" aria-hidden="true" />}
                        </Link>
                    ) : (
                        <button
                            type="button"
                            className={`mobile-menu-level__row${entry.sale ? ' mobile-menu-level__row--sale' : ''}`}
                            onClick={event => entry.onSelect?.(event.currentTarget)}
                        >
                            <span>{entry.label}</span>
                            <Icon name="chevron-right" size="lg" aria-hidden="true" />
                        </button>
                    )}
                </li>
            ))}
        </ul>
    );
}
